module.exports = __webpack_public_path__ + "static/media/chrome.403f1ee0.svg";